import { getAPIDataReturn } from './apiFunction';


const readBlobAsDataUrl = (blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
});

const fetchImageDataUrl = async (url) => {
    if (!url) {
        return null;
    }

    try {
        const response = await fetch(url, { cache: 'no-cache' });
        if (!response.ok) {
            return null;
        }

        const blob = await response.blob();
        return await readBlobAsDataUrl(blob);
    } catch (err) {
        console.error('Unable to fetch company logo from blob storage', err);
        return null;
    }
};

const detectImageFormat = (source) => {
    if (typeof source !== 'string') {
        return 'PNG';
    }

    const lower = source.toLowerCase();
    if (lower.startsWith('data:image/jpeg') || lower.startsWith('data:image/jpg')) {
        return 'JPEG';
    }

    if (lower.endsWith('.jpg') || lower.endsWith('.jpeg')) {
        return 'JPEG';
    }

    return 'PNG';
};

const loadImageElement = (src) => new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
});

const pickPreferredAsset = (assets, preference) => {
    if (!assets || !preference) return null;

    if (Array.isArray(preference)) {
        for (const key of preference) {
            if (assets[key]) return assets[key];
        }
        return null;
    }

    return assets[preference] || null;
};

// preference can be a single key (e.g., 'labelLogo') or an ordered array of keys
export const loadCompanyLabelLogo = async (defaultLogo, preference) => {
    let logoSource = defaultLogo;
    let logoFormat = detectImageFormat(logoSource);
    if (process.env.REACT_APP_EXTERNAL_APP!=='true') {
        const fallback = await loadImageElement(defaultLogo);
        return { image: fallback, format: detectImageFormat(defaultLogo) };
    } else {
        try {
            const companyAssets = await getAPIDataReturn('/Transfers/CompanyAssets');
            const selectedLogoUrl = pickPreferredAsset(companyAssets, preference);
            const dataUrl = await fetchImageDataUrl(selectedLogoUrl);
            if (dataUrl) {
                logoSource = dataUrl;
                logoFormat = detectImageFormat(dataUrl);
            }
        } catch (err) {
            console.error('Falling back to default logo for labels', err);
        }

        try {
            const image = await loadImageElement(logoSource);
            return { image, format: logoFormat };
        } catch (err) {
            console.error('Unable to load company label logo, using default asset', err);
            const fallback = await loadImageElement(defaultLogo);
            return { image: fallback, format: detectImageFormat(defaultLogo) };
        }
    }
};

// Returns a data URL or the default asset for UI <img> tags
export const loadCompanyLogoSrc = async (defaultLogo, preference = 'pageLogo') => {
    let logoSource = defaultLogo;
    if (process.env.REACT_APP_EXTERNAL_APP!=='true') {
        return defaultLogo;
    } else {

        try {
            const companyAssets = await getAPIDataReturn('/Transfers/CompanyAssets');
            const selectedLogoUrl = pickPreferredAsset(companyAssets, preference);
            const dataUrl = await fetchImageDataUrl(selectedLogoUrl);
            if (dataUrl) {
                logoSource = dataUrl;
            }
        } catch (err) {
            console.error('Falling back to default logo for UI', err);
        }

        return logoSource || defaultLogo;
    }
};
